import LinkedIn from '../assets/network/linkedin.png';
import GitHub from '../assets/network/github.png';

const network = [
     {
          name: 'LinkedIn',
          img: LinkedIn,
          link: 'https://www.linkedin.com/in/agustin-manuel-ojeda-916547239/',
     },
     {
          name: 'GitHub',
          img: GitHub,
          link: 'https://github.com/xA6V5x',
     },
];

export default network;
